/*
<summary>
   This functional component is all about rendering the wrapped component with Add Defective Item popup visibility state and its toggle handler.
   Developer: Aashish Singh, Created Date: 20-Aug-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { useState } from 'react';

/**
 * This function is used to wrap a component with Add Defective Item popup visibility state and a toggle handler.
 * @param Component: Component to be wrapped
 */
const AddDefectiveItemPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddDefectiveItemPopup, setShowAddDefectiveItemPopup] =
      useState<boolean>(false);

    /**
     * This function is used to toggle the visibility of the Add Defective Item popup.
     */
    const addToggleHandler = () => {
      setShowAddDefectiveItemPopup(!showAddDefectiveItemPopup);
    };

    return (
      <Component
        showAddDefectiveItemPopup={showAddDefectiveItemPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddDefectiveItemPopupHOC;
